import React, { useState, useEffect, useRef } from "react";
import { useParams, useLocation, useHistory } from "react-router-dom";
import { baseUrl, ROUTE_BASE_URL } from "../../api/common";
import axios from "axios";
import { convertDBDate } from './common';
// import { showToast, ToastMessage } from "../Shared/ToastMessage";
import Loader from "../common/Loader";
import Header from "./Header";
import Footer from "./Footer";
import SingleFileUpload from "../common/SingleDropzoneComponent";
import CustomDropdown from "../common/CustomDropdown";
import { showToast, ToastMessage } from "../Shared/ToastMessage";
import { encryptSlug,decryptSlug } from "../../util/encryption";
const UserMemberApplicationConversion = () => {
  
    const { slug } = useParams();
    const decryptedId = decryptSlug(slug);   
    const useQuery = () => {return new URLSearchParams(useLocation().search)};      
    const query = useQuery();
    const history = useHistory();
    const [applicationId, setApplicationId] = useState(parseInt(decryptSlug(query.get("id"))));  

    const [memberDetails, setMemberDetails] = useState({});
    const [clinicAddress, setClinicAddress] = useState([]);
    const [procedures, setProcedures] = useState([]);

    const fetchMemberDetailsData = async () => {
      try {
        const response = await axios.post(
          `${baseUrl}/api/member_detail`,
          { id: decryptedId },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: localStorage.getItem("access_token"),
            },
          }
        );
        if (response.data.status) {
          setMemberDetails(response.data.data[0]);
          setClinicAddress(response.data.clinic);
          setProcedures(response.data.work_exp);
          console.log(response.data, "fetchMemberDetailsData");
        } else {
          console.error("Error: Failed to fetch user data");
        }
      } catch (error) {
        console.error("Error fetching users data:", error);
      }
    };
  
    const workExpInYears = (from, to) => {
  
      const year1 = new Date(from).getFullYear();
      const year2 = new Date(to).getFullYear();
  
      console.log(year2 - year1);
      return year2 - year1;
    };

    useEffect(() => {
      fetchMemberDetailsData();
    }, [decryptedId]);

    const [formValues, setFormValues] = useState({
      asi_membership_no: "",
      asi_state: "",
    });
  
    const [errors, setErrors] = useState({
      asi_membership_no: "",
      asi_state: "",
      mci_certificate: "",
      pg_degree_certificate: "",
      asi_member_certificate: ""
    });
  
    const handleInputChange = (field, value) => {
      setFormValues({ ...formValues, [field]: value });
    };

    //----------------- NMC Certificate----------------
    const [mciCertificateFile, setMciCertificateFile] = useState(null);
    const [mciCertificateError, setMciCertificateError] = useState("");
    const handleMciCertificateUpload = (uploadedFile) => {
      // setFormValues({ ...formValues, mci_certificate: uploadedFile });
      setMciCertificateFile(uploadedFile);
      console.log("Uploaded File:", uploadedFile);
    };
    //-------------------------------------------------
  
    //----------------- PG Degree Certificate----------------
    const [pgDegreeCertificateFile, setPgDegreeCertificateFile] = useState(null);
    const [pgDegreeCertificateError, setPgDegreeCertificateError] = useState("");
    const handlePgDegreeCertificateUpload = (uploadedFile) => {
      // setFormValues({ ...formValues, pg_degree_certificate: uploadedFile });
      setPgDegreeCertificateFile(uploadedFile);
      console.log("Uploaded File:", uploadedFile);
    };
    //-------------------------------------------------
  
    //----------------- ASI Member Certificate----------------
    const [asiMemberCertificateFile, setAsiMemberCertificateFile] =
      useState(null);
    const [asiMemberCertificateError, setAsiMemberCertificateError] =
      useState("");
    const handleAsiMemberCertificateUpload = (uploadedFile) => {
      // setFormValues({ ...formValues, asi_member_certificate: uploadedFile });
      setAsiMemberCertificateFile(uploadedFile);
      console.log("Uploaded File:", uploadedFile);
    };
    //-------------------------------------------------
  
    const validate = () => {
      const newErrors = {};
  
      const validateField = (field, message) => {
        if (typeof formValues[field] === "string" && !formValues[field].trim()) {
          newErrors[field] = message;
          console.log(field, typeof formValues[field]);
        }
      };
  
      const validateDropdownField = (field, message) => {
        if (!formValues[field]) newErrors[field] = message;
      };

      const validateFile = (file, field, message) => { 
        if(!file ) newErrors[field] = message;
      };
  
      // MCI and ASI fields based on application ID
      if ([5,6].includes(applicationId)) {
        validateField(
          "asi_membership_no",
          "ASI membership number cannot be empty"
        );
        validateDropdownField("asi_state", "ASI state cannot be empty");
      }
  
      // Document validation based on application ID
      if (applicationId === 6) {
        validateFile(
          mciCertificateFile,
          "mci_certificate",
          "NMC certificate cannot be empty"
        );
        validateFile(
          pgDegreeCertificateFile,
          "pg_degree_certificate",
          "PG degree certificate cannot be empty"
        );
        validateFile(
          asiMemberCertificateFile,
          "asi_member_certificate",
          "ASI member certificate cannot be empty"
        );
      } 
      if(applicationId === 5 ) {
        validateFile(
          asiMemberCertificateFile,
          "asi_member_certificate",
          "ASI member certificate cannot be empty"
        );
      }  
      setErrors(newErrors);
      return Object.keys(newErrors).length === 0;
    };
  
    const clearInputValues = () => {
      setErrors({
        asi_membership_no: "",
        asi_state: "",
        mci_certificate: "",
        pg_degree_certificate: "",
        asi_member_certificate: ""
      });  
    };
  
    const addUpdateMembershipApplication = async () => {
      if (validate()) {  
        try {
          const apiEndpoint = `${baseUrl}/api/member_conversion`;
          const requestData = {
            ...formValues,
            ...{ membership_no: memberDetails.membership_no || "" },
            ...{ application_id: applicationId || "" },
            ...{ asi_member_certificate: asiMemberCertificateFile || "" },    
            ...{id: decryptedId},
            ...(applicationId === 6 && {
               mci_certificate: mciCertificateFile || "",
               pg_degree_certificate: pgDegreeCertificateFile || "",
            })
          };
          console.log("Update requestData Data:", requestData);
          const response = await axios.post(apiEndpoint, requestData, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: localStorage.getItem("access_token"),
            },
          });
          if (response.data.status) {
            showToast(response.data.message, "success");
            console.log(response.data, "response.data");   
            clearInputValues();
            history.push(`${ROUTE_BASE_URL}/user-member-application-payment/${encryptSlug(`${response.data.application_no}`)}?id=${encryptSlug(`${applicationId}`)}`);
          } else {
            showToast(response.data.message, "error");
          }
        }catch (err) {
            console.error("Error in InsertMembersPersonal:", err);
        
            let message = "A network error occurred. Please try again later.";
        
            if (err.response) {
              // Server returned error (400, 500, etc.)
              message =
                err.response.data?.message ||
                err.response.data?.error ||
                `Server error (${err.response.status})`;
            } else if (err.request) {
              // Request was made but no response
              message = "No response from server. Please check your internet connection.";
            } else {
              // Something else went wrong
              message = err.message || "Request failed";
            }
        
            // throw new Error(message);
            showToast(message, "error");
          }
        //  catch (error) {
        //   console.error("Error during submission:", error);
        //   showToast("A network error occurred, or the server is temporarily busy. Please try again later.", "error");
        // }
      } else {
        showToast("Please fill in the required details.", "error");
      }
    };
    const [asiMciStateData, setAsiMciStateData] = useState([]);
    const fetchStateData = async (countryId) => {
      try {
        const response = await axios.post(
          `${baseUrl}/api/get_state`,
          { id: countryId },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: localStorage.getItem("access_token"),
            },
          }
        );
  
        if (response.data.status) {
          return response.data.data;
        } else {
          console.error("Error: Failed to fetch state data");
          return [];
        }
      } catch (error) {
        console.error("Error fetching state data:", error);
        return [];
      }
    };  
    useEffect(() => {
      const loadStateData = async () => {
        const data = await fetchStateData(101);
        console.log(data, "msi");
  
        setAsiMciStateData(data);
      };
  
      loadStateData();
    }, []); 

    const [memberApplicationName, setMemberApplicationName] = useState("");
    const fetchMembershipPackageData = async () => {
      try {
        const response = await axios.get(`${baseUrl}/api/get_application`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("access_token"),
          },
        });
  
        if (response.data.status) {
            const applicationData = response.data.data.find((item) => `${item.id}` === `${applicationId}`);
            setMemberApplicationName(applicationData.application_name);
        } else {
          console.error("Error: Failed to fetch user data");
        }
      } catch (error) {
        console.error("Error fetching users data:", error);
      }
    };  
  
    useEffect(() => {
      fetchMembershipPackageData();
    //   fetchMemberDetailsData();
    }, []);

    return (
        <>    
            <section className="user_div_total">
                <ToastMessage />
                <Header/>
                <div className="container pt-50">
                    <div className="row">
                        <div className="col-md-12">                        
                        <div className="row">
                            <div className="col-md-12">
                            <div className="tracking_head">
                                <h3>Online Membership Application System (OMAS) {memberApplicationName}</h3>
                            </div>
                            </div>
                        </div>
                        <div className="card member_master_sidebar_scrool">
                        {memberDetails ? (
                            <div className="table-responsive">
                                <div className="body  application_body_side">
                                <fieldset>
                                    <div className="row clearfix">
                                    <div className="col-md-12">
                                        <div className="row">
                                        <div className="col-md-3">
                                            <div>
                                            {memberDetails.profile ? (
                                                <img
                                                src={`${memberDetails.profile}`}
                                                width="80"
                                                height="80"
                                                className="img-thumbnail rounded-circle width_profile_image"
                                                alt="person"
                                                />
                                            ) : (
                                                <img
                                                src="../assets/images/user_image.png"
                                                width="80"
                                                height="80"
                                                className="img-thumbnail rounded-circle width_profile_image"
                                                alt="person"
                                                />
                                            )}
                                            </div>
                                        </div>
                                        <div className="col-md-9">
                                            <div className="application_id_date_flex pb-3">
                                            <div>
                                            <small className="text-muted">
                                                <b>
                                                    {memberDetails.salutation || memberDetails.first_name || memberDetails.middle_name || memberDetails.last_name
                                                    ? `${memberDetails.salutation || ''} ${memberDetails.first_name || ''} ${memberDetails.middle_name || ''} ${memberDetails.last_name || ''}`
                                                        .trim()
                                                        .replace(/\s+/g, ' ')
                                                    : 'N/A'}
                                                </b>{" "}
                                            </small>
                                            </div>
                                            </div>
                                            <div className="application_id_date_flex">
                                            <div>
                                                <small className="text-muted">
                                                <b>Application No:</b>
                                                </small>
                                                 <p>{memberDetails.application_no?` ${memberDetails.application_no}`:'N/A'}</p>
                                            </div>
                                            <div>
                                                <small className="text-muted">
                                                <b>Membership Number:</b>
                                                </small>
                                                <p>{` ${memberDetails.membership_no}`}</p>
                                            </div>
                                            <div>
                                                <small className="text-muted">
                                                <b>Application Date:</b>{" "}
                                                </small>
                                                <p>
                                                {convertDBDate(memberDetails.created_on)}
                                                </p>
                                            </div>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12 pt-3 pb-2">
                                        <div className="row">
                                        <div className="col-md-8">
                                            <small className="text-muted">
                                            <b>To</b>{" "}
                                            </small>
                                            <p>
                                            The Honorary Secretary General,
                                            <br />
                                            Association of Minimal Access Surgeons of India
                                            (AMASI)
                                            </p>
                                        </div>
                                        </div>

                                        <small className="text-muted">
                                        <b>Dear Sir,</b>{" "}
                                        </small>
                                        <p>
                                        I wish to become a {memberDetails.application_name} of the
                                        Association and if selected, I agree to abide by the
                                        rules and regulations of the Association. I hereby
                                        declare that the information provided by me is correct
                                        and if found incorrect my membership may be forfeited.
                                        </p>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="card">
                                        <div className="header">
                                            <h2>Info</h2>
                                        </div>
                                        <div className="body">
                                            <div className="row">
                                            <div className="col-6">
                                                <small className="text-muted">
                                                <b>First Name:</b>{" "}
                                                </small>
                                                <p>{memberDetails.first_name || "N/A"}</p>
                                            </div>
                                           <div className="col-6">
                                                <small className="text-muted">
                                                <b>Middle Name: </b>
                                                </small>
                                                <p>{memberDetails.middle_name || "N/A"}</p>
                                            </div>
                                            <div className="col-6">
                                                <small className="text-muted">
                                                <b>Last Name: </b>
                                                </small>
                                                <p>{memberDetails.last_name || "N/A"}</p>
                                            </div>
                                            <div className="col-6">
                                                <small className="text-muted">
                                                <b>Father's Name: </b>
                                                </small>
                                                <p>{memberDetails.father_name || "N/A"}</p>
                                            </div>
                                            <div className="col-6">
                                                <small className="text-muted">
                                                <b>Date of Birth: </b>
                                                </small>
                                                <p>
                                               {memberDetails.dob?convertDBDate(memberDetails.dob) : "N/A"}
                                                </p>
                                            </div>
                                            <div className="col-6">
                                            <small className="text-muted">
                                                <b>Date of Joining: </b>
                                            </small>
                                            <p>
                                               {memberDetails.joining_date?convertDBDate(memberDetails.joining_date) : "N/A"}    
                                            </p>
                                            </div>
                                            <div className="col-6">
                                                <small className="text-muted">
                                                <b>Email address: </b>
                                                </small>
                                                <p>{memberDetails.email || "N/A"}</p>
                                            </div>
                                            <div className="col-6">
                                                <small className="text-muted">
                                                <b>Mobile: </b>
                                                </small>
                                                <p>{memberDetails.mobile || "N/A"}</p>
                                            </div>
                                            <div className="col-6">
                                                <small className="text-muted">
                                                <b>Nationality: </b>
                                                </small>
                                                <p>{memberDetails.nationality || "N/A"}</p>
                                            </div>
                                            <div className="col-6">
                                                <small className="text-muted">
                                                <b>Gender: </b>
                                                </small>
                                                <p>{memberDetails.gender || "N/A"}</p>
                                            </div>
                                            <div className="col-6">
                                                <small className="text-muted">
                                                <b>AGE: </b>
                                                </small>
                                                <p>{memberDetails.age || "N/A"}</p>
                                            </div>
                                            <div className="col-6">
                                                    <small className="text-muted">
                                                        <b>City / District: </b>
                                                    </small>
                                                    <p>{memberDetails.city || "N/A"}</p>
                                                    </div>
                                                    <div className="col-6">
                                                    <small className="text-muted">
                                                        <b>State: </b>
                                                    </small>
                                                    <p>{memberDetails.state_name || "N/A"}</p>
                                                    </div>
                                                    <div className="col-6">
                                                    <small className="text-muted">
                                                        <b>Zone: </b>
                                                    </small>
                                                    <p>{memberDetails.zone || "N/A"}</p>
                                                    </div>
                                                    <div className="col-6">
                                                    <small className="text-muted">
                                                        <b>Country: </b>
                                                    </small>
                                                    <p>{memberDetails.country_name || "N/A"}</p>
                                                    </div>
                                            <div className="col-12">
                                                <small className="text-muted">
                                                <b>Permanent Address: </b>
                                                </small>
                                                <p>
                                                {`${memberDetails.street_line1 || ""}, ${memberDetails.street_line2 || ""
                                                    }, ${memberDetails.city || ""}, ${memberDetails.state_name || ""
                                                    }, ${memberDetails.country_name || ""}, ${memberDetails.pin || ""
                                                    }`}
                                                </p>
                                            </div>
                                            <div className="col-12">
                                                <small className="text-muted">
                                                <b>Mailing Address:</b>{" "}
                                                </small>
                                                <p>
                                                {`${memberDetails.street_line1 || ""}, ${memberDetails.street_line2 || ""
                                                    }, ${memberDetails.city || ""}, ${memberDetails.state_name || ""
                                                    }, ${memberDetails.country_name || ""}, ${memberDetails.pin || ""
                                                    }`}
                                                </p>
                                            </div>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        <div className="table_profile_list_border ">
                                        <div className="card">
                                            <div className="header">
                                            <h2>Qualifications </h2>
                                            </div>
                                            <div className="body overflow_auto">
                                            <table
                                                id="row-table"
                                                className="table table-striped"
                                            >
                                                <thead>
                                                <tr>
                                                    <th>Qualification Name</th>
                                                    <th>Degree</th>
                                                    <th>College</th>
                                                    <th>University</th>
                                                    <th>Year of Passing</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr>
                                                    <td>MBBS</td>
                                                    <td>N/A</td>
                                                    <td>
                                                    {memberDetails.edu_undergrad_college ||
                                                        "N/A"}
                                                    </td>
                                                    <td>
                                                    {memberDetails.edu_undergrad_university ||
                                                        "N/A"}
                                                    </td>
                                                    <td>
                                                    {memberDetails.edu_undergrad_year ||
                                                        "N/A"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Post Graduation</td>
                                                    <td>
                                                    {memberDetails.edu_postgrad_degree ||
                                                        "N/A"}
                                                    </td>
                                                    <td>
                                                    {memberDetails.edu_postgrad_college ||
                                                        "N/A"}
                                                    </td>
                                                    <td>
                                                    {memberDetails.edu_postgrad_university ||
                                                        "N/A"}
                                                    </td>
                                                    <td>
                                                    {memberDetails.edu_postgrad_year || "N/A"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>Super Speciality</td>
                                                    <td>
                                                    {memberDetails.edu_superspecialty_degree ||
                                                        "N/A"}
                                                    </td>
                                                    <td>
                                                    {memberDetails.edu_superspecialty_college ||
                                                        "N/A"}
                                                    </td>
                                                    <td>
                                                    {memberDetails.edu_superspecialty_university ||
                                                        "N/A"}
                                                    </td>
                                                    <td>
                                                    {memberDetails.edu_superspecialty_year ||
                                                        "N/A"}
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                            </div>
                                        </div>
                                        </div>
                                        <div className="card">
                                        <div className="body">
                                            <div className="row">
                                            <div className="col-6">
                                                <small className="text-muted">
                                                <b>NMC/State Medical Council number: </b>
                                                </small>
                                                <p>
                                                {memberDetails.mci_council_number || "N/A"}{" "}
                                                </p>
                                            </div>
                                            <div className="col-6">
                                                <small className="text-muted">
                                                <b>NMC State: </b>
                                                </small>
                                                <p>
                                                {memberDetails.mci_council_state_name || "N/A"}
                                                </p>
                                            </div>
                                            <div className="col-6">
                                                <small className="text-muted">
                                                <b>IMR Number: </b>
                                                </small>
                                                <p>{memberDetails.imr_reg_no || "N/A"}</p>
                                            </div>
                                            <div className="col-6">
                                                <small className="text-muted">
                                                <b>Any other international Organisations: </b>
                                                </small>
                                                <p>
                                                {memberDetails.other_inter_organisation ||
                                                    "N/A"}
                                                </p>
                                            </div>
                                            <div className="col-6">
                                                <small className="text-muted">
                                                <b>Please Mention (If others): </b>
                                                </small>
                                                <p>{memberDetails.other_inter_organisation_value || "N/A"}</p>
                                            </div>
                                            <div className="col-6">
                                                <small className="text-muted">
                                                <b>ASI Registration Number: </b>
                                                </small>
                                                <p>
                                                {memberDetails.asi_membership_no || "N/A"}
                                                </p>
                                            </div>
                                            <div className="col-6">
                                                <small className="text-muted">
                                                <b>ASI State: </b>
                                                </small>
                                                <p>{memberDetails.asi_state_name || "N/A"}</p>
                                            </div>
                                            </div>
                                        </div>
                                        </div>
                                        <div className="table_profile_list_border ">
                                        <div className="card">
                                            <div className="header">
                                            <h2>Work Experience </h2>
                                            </div>
                                            <div className="body overflow_auto">
                                            <table
                                                id="row-table"
                                                className="table table-striped"
                                            >
                                                <thead>
                                                <tr>
                                                    <th>Position</th>
                                                    <th>Experience (From)</th>
                                                    <th>Experience (To)</th>
                                                    <th>Total Experience (Years)</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {procedures && procedures.length > 0 ? (
                                                    procedures.map((procedure, index) => (
                                                    <tr key={index}>
                                                        <td>
                                                        {procedure.work_procedure || "NA"}
                                                        </td>
                                                        <td>
                                                        {procedure.no_of_procedures1 || "NA"}
                                                        </td>
                                                        <td>
                                                        {procedure.no_of_procedures2 || "NA"}
                                                        </td>
                                                        <td>
                                                        {workExpInYears(procedure.no_of_procedures1, procedure.no_of_procedures2) || "NA"}
                                                        </td>
                                                    </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                    <td colSpan="4" className="text-center">
                                                        No procedure data available
                                                    </td>
                                                    </tr>
                                                )}
                                                </tbody>
                                            </table>
                                            </div>

                                        </div>
                                        </div>
                                        <div className="table_profile_list_border ">
                                        <div className="card">
                                            <div className="header">
                                            <h2>Clinic / Hospital Address</h2>
                                            </div>
                                            <div className="body overflow_auto">
                                            <table
                                                id="row-table"
                                                className="table table-striped"
                                            >
                                                <thead>
                                                <tr>
                                                    <th>Clinic Name</th>
                                                    <th>Address</th>
                                                    <th>Country</th>
                                                    <th>State</th>
                                                    <th>City</th>
                                                    <th>Pin</th>
                                                    <th>Landline</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {clinicAddress && clinicAddress.length > 0 ? (
                                                    clinicAddress.map((clinic, index) => (
                                                    <tr key={index}>
                                                        <td>{clinic.clinic_name || "NA"}</td>
                                                        <td>
                                                        {clinic.clinic_address_one || clinic.clinic_address_two
                                                            ? `${clinic.clinic_address_one || ''} ${clinic.clinic_address_two || ''}`.trim().replace(/\s+/g, ' ')
                                                            : 'N/A'}
                                                        </td>
                                                        <td>
                                                        {clinic.clinic_country_name || "NA"}
                                                        </td>
                                                        <td>
                                                        {clinic.clinic_state_name || "NA"}
                                                        </td>
                                                        <td>{clinic.clinic_city || "NA"}</td>
                                                        <td>
                                                        {clinic.clinic_pin_code || "NA"}
                                                        </td>
                                                        <td>
                                                        {clinic.clinic_stdcode
                                                            ? `(${clinic.clinic_stdcode}) ${clinic.clinic_landline}`
                                                            : clinic.clinic_landline || "NA"}
                                                        </td>
                                                    </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                    <td colSpan="7" className="text-center">
                                                        No clinic data available
                                                    </td>
                                                    </tr>
                                                )}
                                                </tbody>
                                            </table>
                                            </div>
                                        </div>
                                        </div>
                                        <div className="table_profile_list_border ">
                                        <div className="card">
                                            <div className="header">
                                            <h2>Documents</h2>
                                            </div>
                                            <div className="body overflow_auto">
                                            <table
                                                id="row-table"
                                                className="table table-striped"
                                            >
                                                <thead>
                                                <tr>
                                                    <th>Document Name</th>
                                                    <th className="">File</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {([1, 2, 6].includes(
                                                    memberDetails.application_id
                                                ) && `${memberDetails.country}`==="101") && (
                                                    <tr>
                                                        <td>NMC Certificate</td>
                                                        <td className="text-wecenter">
                                                        {/* <button
                                                            className="btn btn-outline-info btn-block width-fit"
                                                            type="button"
                                                            >
                                                            View Document
                                                            </button> */}
                                                        <a
                                                            href={`${memberDetails.mci_certificate}`}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="btn btn-outline-info btn-block width-fit"
                                                        >
                                                            View Document
                                                        </a>
                                                        </td>
                                                    </tr>
                                                    )}
                                                {([1, 2, 3, 6].includes(
                                                    memberDetails.application_id
                                                )|| `${memberDetails.country}`!=="101") && (
                                                    <tr>
                                                        <td>
                                                        Post Graduation Degree Certificate
                                                        </td>
                                                        <td className="text-wecenter">
                                                        <a
                                                            href={`${memberDetails.pg_degree_certificate}`}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="btn btn-outline-info btn-block width-fit"
                                                        >
                                                            View Document
                                                        </a>
                                                        </td>
                                                    </tr>
                                                    )}
                                                {([1, 5, 6].includes(
                                                    memberDetails.application_id
                                                )&& `${memberDetails.country}`==="101") &&  (
                                                    <tr>
                                                        <td>ASI Membership Certificate</td>
                                                        <td className="text-wecenter">
                                                        <a
                                                            href={`${memberDetails.asi_member_certificate}`}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="btn btn-outline-info btn-block width-fit"
                                                        >
                                                            View Document
                                                        </a>
                                                        </td>
                                                    </tr>
                                                    )}
                                                {([3].includes(
                                                    memberDetails.application_id
                                                )|| `${memberDetails.country}`!=="101") && (
                                                    <tr>
                                                        <td>
                                                        Active License for Practicing Surgeons
                                                        </td>
                                                        <td className="text-wecenter">
                                                        <a
                                                            href={`${memberDetails.active_license}`}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="btn btn-outline-info btn-block width-fit"
                                                        >
                                                            View Document
                                                        </a>
                                                        {/* <button
                                                            className="btn btn-outline-info btn-block width-fit"
                                                            type="button"
                                                            >
                                                            View Document
                                                            </button> */}
                                                        </td>
                                                    </tr>
                                                    )}
                                                {([4].includes(
                                                    memberDetails.application_id
                                                )&& `${memberDetails.country}`==="101") &&  (
                                                    <tr>
                                                        <td>Letter from HOD</td>
                                                        <td className="text-wecenter">
                                                        <a
                                                            href={`${memberDetails.letter_hod}`}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="btn btn-outline-info btn-block width-fit"
                                                        >
                                                            View Document
                                                        </a>
                                                        </td>
                                                    </tr>
                                                    )}
                                                {([4].includes(
                                                    memberDetails.application_id
                                                ) && `${memberDetails.country}`==="101") && (
                                                    <tr>
                                                        <td>MBBS Degree certificate</td>
                                                        <td className="text-wecenter">

                                                        <a
                                                            href={`${memberDetails.mbbs_degree_certificate}`}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="btn btn-outline-info btn-block width-fit"
                                                        >
                                                            View Document
                                                        </a>
                                                        </td>
                                                    </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                            </div>
                                        </div>
                                        </div>
                                        <div className="table_profile_list_border ">
                                        <div className="card">
                                            <div className="header">
                                            <h2>Conversion Documents</h2>
                                            </div>
                                            <div className="body overflow_auto"> 
                                            <div className="row clearfix">                                      
                                            {[5,6].includes(applicationId) && (
                                            <div className="col-lg-6 col-md-12">
                                                <div className="form-group pos_relative">
                                                <label>
                                                    ASI Membership Number{" "}
                                                    <span className="text-danger">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className={`form-control ${errors.asi_membership_no ? "red_border" : ""
                                                    }`}
                                                    value={formValues.asi_membership_no}
                                                    onChange={(e) => {
                                                        let input = e.target.value;
                                                        input = input.replace(
                                                          /[^A-Za-z0-9]/g,
                                                          ""
                                                        );
                                                        handleInputChange(
                                                          "asi_membership_no",
                                                          input
                                                        );
                                                      }}
                                                />
                                                <small>
                                                    (Only numbers and alphabetic characters are
                                                    allowed.)
                                                </small>
                                                {errors && (
                                                    <p className="text-danger pos_abos">
                                                    {errors.asi_membership_no}
                                                    </p>
                                                )}
                                                </div>
                                            </div>
                                            )}
                                            {[5,6].includes(applicationId) && (
                                            <div className="col-lg-6 col-md-12 personal_details_dropdown">
                                                <div className="form-group pos_relative">
                                                <label>
                                                    ASI State <span className="text-danger">*</span>
                                                </label>
                                                <div className="multiselect_div">
                                                    <CustomDropdown
                                                    dropdownData={asiMciStateData}
                                                    dropdownValue={formValues.asi_state}
                                                    setDropdownValue={(value) =>
                                                        handleInputChange("asi_state", value)
                                                    }
                                                    name="Asi state"
                                                    fieldName="asi_state"
                                                    errors={errors}
                                                    formValues={formValues}
                                                    ShouldValidate={true}
                                                    eventType={"Update"}
                                                    FeildName={"common"}
                                                    />
                                                </div>
                                                </div>
                                            </div>
                                            )}
                                            </div>   
                                            {([6].includes(applicationId)) && (
                                                <div className="col-md-12 col-12  pos_relative">
                                                    <div className="dropdown_cetifica_div">
                                                    <label>
                                                        NMC Certificate{" "}
                                                        <span className="text-danger">*</span>
                                                    </label>
                                                    <br />
                                                    <small>
                                                        (Maximum file size allowed: 2MB ){" "}
                                                        <span>
                                                        Kindly do not upload password-protected pdf's
                                                        </span>{" "}
                                                    </small>
                                                    </div>
                                                    <SingleFileUpload
                                                    onFileUpload={handleMciCertificateUpload}
                                                    setFileError={setMciCertificateError}
                                                    />
                                                    {mciCertificateError && (
                                                    <p className="text-danger pos_abos left_15">
                                                        {mciCertificateError}
                                                    </p>
                                                    )}
                                                    {errors && (
                                                    <p className="text-danger pos_abos left_15">
                                                        {errors.mci_certificate}
                                                    </p>
                                                    )}
                                                </div>
                                            )}

                                            {([6].includes(applicationId)) && (
                                                <div className="col-md-12 col-12  pos_relative">
                                                    <div className="dropdown_cetifica_div">
                                                    <label>
                                                        PG Degree Certificate{" "}
                                                        <span className="text-danger">*</span>
                                                    </label>
                                                    <br />
                                                    <small>
                                                        (Maximum file size allowed: 2MB ){" "}
                                                        <span>
                                                        Kindly do not upload password-protected pdf's
                                                        </span>{" "}
                                                    </small>
                                                    </div>
                                                    <SingleFileUpload
                                                    onFileUpload={handlePgDegreeCertificateUpload}
                                                    setFileError={setPgDegreeCertificateError}
                                                    />
                                                    {pgDegreeCertificateError && (
                                                    <p className="text-danger pos_abos left_15">
                                                        {pgDegreeCertificateError}
                                                    </p>
                                                    )}
                                                    {errors && (
                                                    <p className="text-danger pos_abos left_15">
                                                        {errors.pg_degree_certificate}
                                                    </p>
                                                    )}
                                                </div>
                                            )}

                                            {[5, 6].includes(applicationId) && (
                                                <div className="col-md-12 col-12  pos_relative">
                                                <div className="dropdown_cetifica_div">
                                                    <label>
                                                    ASI Membership Certificate{" "}
                                                    <span className="text-danger">*</span>
                                                    </label>
                                                    <br />
                                                    <small>
                                                    (Maximum file size allowed: 2MB ){" "}
                                                    <span>
                                                        Kindly do not upload password-protected pdf's
                                                    </span>{" "}
                                                    </small>
                                                </div>
                                                <SingleFileUpload
                                                    onFileUpload={handleAsiMemberCertificateUpload}
                                                    setFileError={setAsiMemberCertificateError}
                                                />
                                                {asiMemberCertificateError && (
                                                    <p className="text-danger pos_abos left_15">
                                                    {asiMemberCertificateError}
                                                    </p>
                                                )}
                                                {errors && (
                                                    <p className="text-danger pos_abos left_15">
                                                    {errors.asi_member_certificate}
                                                    </p>
                                                )}
                                                </div>
                                            )}

                                             </div>
                                            </div>
                                            </div>
                                        </div>

                                        <div className="col-md-12">
                                        <div className="last_form_submit_flex">                    
                                            <div>
                                            <button
                                                className="btn btn-outline-success btn-block saveand_proced_button"
                                                onClick={() => addUpdateMembershipApplication()}
                                                type="button"
                                            >
                                                Submit
                                            </button>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                </fieldset>
                                </div>
                            </div>
                            ) : <Loader />}
                        </div>
                        </div>
                    </div>
                </div>
                <Footer/>
            </section>
        </>
    );

}


export default UserMemberApplicationConversion
